import { debounce } from "lodash";
import uuid from "uuid/v1";

import { isWeb } from "../constants/Config";
import firebase, {
  signOut,
  allSaveToFirebase,
  getAllDataFromFirebase,
  saveMemoToFirebase,
  deleteMemoOnFirebase,
  saveCatToFirebase,
  saveOrderToFirebase,
  deleteCatOnFirebase,
} from "../assets/js/firebase";
import store from "../store";
import firstMemoText from "../assets/others/firstMemo";

const MAX_CATEGORY_NAME_LENGTH = 15;

export const setScreenSize = ({
  width,
  height,
}: {
  width: number;
  height: number;
}) => ({
  type: "SET_SCREEN_SIZE",
  payload: { width, height },
});

export const setTextSize = (memoFontSize: number) => ({
  type: "SET_MEMO_FONTSIZE",
  payload: { memoFontSize },
});

export const addMemo = ({ id, cat }: { id: string; cat: string }) => {
  const { uid } = store.getState().user;
  if (uid) {
    saveMemoToFirebase({
      uid,
      memoId: id,
      memo: {
        text: "",
        cat: [cat],
        _createdAt: new Date(),
      },
    });
  }
  return {
    type: "ADD_MEMO",
    id,
    cat,
  };
};

const debounseSaveMemo = debounce(args => {
  saveMemoToFirebase(args);
}, 3000);
export const saveMemo = ({ id, text }: { id: string; text: string }) => {
  const { uid } = store.getState().user;
  if (uid) {
    debounseSaveMemo({
      uid,
      memoId: id,
      memo: { text },
    });
  }
  return {
    type: "SAVE_MEMO",
    id,
    text,
  };
};

export const archiveMemo = ({ id }: { id: string }) => {
  const currentMemos = store.getState().memos;
  const { uid } = store.getState().user;
  if (uid) {
    saveMemoToFirebase({
      uid,
      memoId: id,
      memo: { ...currentMemos[id], cat: [] },
    });
  }
  return {
    type: "ARCHIVE_MEMO",
    id,
  };
};

export const deleteMemo = ({ id, isNotDeleteOnFirebase = false }) => {
  const { uid } = store.getState().user;
  if (uid && !isNotDeleteOnFirebase) {
    deleteMemoOnFirebase({
      uid,
      memoId: id,
    });
  }
  return {
    type: "DELETE_MEMO",
    id,
  };
};

export const checkYetUploadMemos = memosOnFirebase => {
  const currentMemos = store.getState().memos;
  const { uid } = store.getState().user;
  return async dispatch =>
    //ローカルに未アップロードデータが無いかチェックして、あったらアップロード
    Object.keys(currentMemos).map(currentMemoKey => {
      if (!Object.keys(memosOnFirebase).includes(currentMemoKey)) {
        return saveMemoToFirebase({
          uid,
          memoId: currentMemoKey,
          memo: currentMemos[currentMemoKey],
        });
      }
      return null;
    });
};

export const restoreMemos = memos => {
  const currentMemos = store.getState().memos;
  return async dispatch =>
    Object.keys(memos).map(key => {
      //ダウンロード済データかどうかの判定
      if (!currentMemos[key]) {
        return dispatch({
          type: "RESTORE_MEMO",
          id: key,
          memo: {
            ...memos[key],
            _createdAt: new Date(memos[key]._createdAt.toDate()),
            _modifiedAt: new Date(memos[key]._modifiedAt.toDate()),
          },
        });
      } else {
        //済の場合 編集時間を見ての最新版とりこみ
        const cloudMemoModifyDate = memos[key]._modifiedAt.toDate();
        const currentMemoModifyDate = new Date(currentMemos[key]._modifiedAt);
        if (cloudMemoModifyDate.getTime() > currentMemoModifyDate.getTime()) {
          return dispatch({
            type: "RESTORE_MEMO",
            id: key,
            memo: {
              ...memos[key],
              //保存に失敗していたメモがあったら入れておく
              _createdAt: memos[key]._createdAt
                ? new Date(memos[key]._createdAt.toDate())
                : new Date(),
              _modifiedAt: new Date(memos[key]._modifiedAt.toDate()),
            },
          });
        }
      }
      return null;
    });
};

export const deleteAllMemo = (isPutTutorialMemo = true) => {
  return async dispatch => {
    dispatch({
      type: isPutTutorialMemo
        ? "DELETE_ALL_MEMO"
        : "DELETE_ALL_MEMO_WITHOUT_FIRSTMEMO",
    });
    dispatch({
      type: "DELETE_ALL_CATEGORY",
    });
  };
};

export const changeMemoCategory = ({ id, categoryId }) => {
  const { uid } = store.getState().user;
  const memo = store.getState().memos[id];
  if (uid) {
    saveMemoToFirebase({
      uid,
      memoId: id,
      memo: { ...memo, cat: [categoryId] },
    });
  }
  return {
    type: "CHANGE_MEMO_CATEGORY",
    id,
    categoryId,
  };
};

export const checkDeletedMemo = deletedMemos => {
  const { memos } = store.getState();
  return async dispatch => {
    Object.keys(memos).map(async memoId => {
      if (deletedMemos && deletedMemos.includes(memoId)) {
        await dispatch(deleteMemo({ id: memoId }));
      }
    });
  };
};

export const addCategory = ({ categoryName }) => {
  if (categoryName.length > MAX_CATEGORY_NAME_LENGTH) {
    categoryName = categoryName.substr(0, MAX_CATEGORY_NAME_LENGTH);
  }
  const newCatId = uuid();
  const { uid } = store.getState().user;
  const { categories } = store.getState();
  if (uid) {
    saveCatToFirebase({
      uid,
      catId: newCatId,
      cat: {
        name: categoryName,
      },
    });
    saveOrderToFirebase({
      uid,
      order: [...categories.order, newCatId],
    });
  }
  return {
    type: "ADD_CATEGORY",
    categoryName,
    id: newCatId,
  };
};

export const setTabCategory = tabCategory => ({
  type: "SET_TAB_CATEGORY",
  tabCategory,
});

export const renameCategory = ({ id, categoryName }) => {
  if (categoryName.length > MAX_CATEGORY_NAME_LENGTH) {
    categoryName = categoryName.substr(0, MAX_CATEGORY_NAME_LENGTH);
  }
  const { uid } = store.getState().user;
  if (uid) {
    saveCatToFirebase({
      uid,
      catId: id,
      cat: {
        name: categoryName,
      },
    });
  }
  return {
    type: "RENAME_CATEGORY",
    id,
    categoryName,
  };
};

export const removeCategory = ({ id }) => {
  const { uid } = store.getState().user;
  if (uid) {
    deleteCatOnFirebase({
      uid,
      catId: id,
    });
  }
  return {
    type: "REMOVE_CATEGORY",
    id,
  };
};

export const restoreCategory = (list, order) => {
  const { uid } = store.getState().user;
  const { categories } = store.getState();
  const newOrder = [...order];
  const newList = { ...list };
  // ローカルのみのカテゴリがあった場合にアップロード
  categories.order.map(catId => {
    if (!order.includes(catId)) {
      newOrder.push(catId);
      newList[catId] = categories.list[catId];
      saveCatToFirebase({
        uid,
        catId,
        cat: categories.list[catId],
      });
      saveOrderToFirebase({
        uid,
        order: newOrder,
      });
    }
    return null;
  });

  return {
    type: "RESTORE_CATEGORY",
    list: newList,
    order: newOrder,
  };
};

export const checkDeletedCategory = deleted => {
  const { categories } = store.getState();
  return async dispatch => {
    categories.order.map(async catId => {
      if (deleted && deleted.includes(catId)) {
        await dispatch(removeCategory({ id: catId }));
      }
    });
  };
};

export const consistentCatOrder = () => {
  const { uid } = store.getState().user;
  const { list } = store.getState().categories;
  const newOrder = Object.keys(list);
  if (uid) {
    saveOrderToFirebase({
      uid,
      order: newOrder,
    });
  }
  return {
    type: "SET_NEW_ORDER_CATEGORY",
    newOrder,
  };
};

const debounseSaveOrder = debounce(args => {
  saveOrderToFirebase(args);
}, 3000);
export const setNewOrderCategory = newOrder => {
  const { uid } = store.getState().user;
  if (uid) {
    debounseSaveOrder({ uid, order: newOrder });
  }
  return {
    type: "SET_NEW_ORDER_CATEGORY",
    newOrder,
  };
};

export const toggleMenuOpen = () => ({
  type: "TOGGLE_MENU_OPEN",
});

export const setCurrentRouteName = currentRouteName => ({
  type: "SET_CURRENT_ROUTE_NAME",
  currentRouteName,
});

export const toggleHiddenPreview = () => ({
  type: "TOGGLE_HIDDEN_PREVIEW",
});

export const toggleOpenMenuBySwipe = () => ({
  type: "TOGGLE_OPEN_MENU_BY_SWIPE",
});

export const toggleIncludeSpace = () => ({
  type: "TOGGLE_INCLUDE_SPACE",
});

export const hasTutorialShow = () => ({
  type: "HAS_TUTORIAL_SHOW",
});

export const setUserData = ({ key, data }) => ({
  type: "SET_USER_DATA",
  key,
  data,
});

export const deleteAllUserData = () => {
  return async dispatch => {
    dispatch({ type: "DELETE_ALL_USER_DATA" });
    dispatch({ type: "DID_SYNC" });
  };
};

export const logout = ({ isLocalDataDelete }) => {
  return async dispatch => {
    await signOut();
    if (isLocalDataDelete) {
      dispatch(deleteAllMemo(false));
    }
    dispatch({
      type: "DELETE_ALL_USER_DATA",
    });
  };
};

export const login = ({ currentUser, isFirstLogin }) => {
  return async dispatch => {
    const { memos, categories } = store.getState();
    dispatch(setUserData({ key: "uid", data: currentUser.uid }));
    dispatch(setUserData({ key: "email", data: currentUser.email }));
    if (isFirstLogin) {
      allSaveToFirebase({
        uid: currentUser.uid,
        memos,
        categories,
      });
    } else {
      await dispatch(processingAtLogin());
    }
    dispatch({ type: "DID_SYNC" });
  };
};

export const processingAtLogin = () => {
  const { currentUser } = firebase.auth();
  const { memos, common } = store.getState();
  if (!currentUser?.uid) {
    return;
  }
  return async dispatch => {
    // 既ログインだけど初期メモが手つかずで残っていたら削除する
    Object.keys(memos).map(memoId => {
      if (memos[memoId].text === firstMemoText) {
        dispatch(deleteMemo({ id: memoId, isNotDeleteOnFirebase: true }));
      }
      return null;
    });

    let {
      memosOnFirebase,
      categoryList,
      categoryOrder,
      deletedCategories,
      deletedMemos,
    } = await getAllDataFromFirebase({
      uid: currentUser.uid,
    });
    if (!categoryOrder) {
      categoryOrder = [];
    }
    await dispatch(restoreCategory(categoryList, categoryOrder));
    await dispatch(checkDeletedCategory(deletedCategories));

    if (memosOnFirebase) {
      await dispatch(checkYetUploadMemos(memosOnFirebase));
      await dispatch(restoreMemos(memosOnFirebase));
      await dispatch(checkDeletedMemo(deletedMemos));
      if (!common.isSynced && isWeb) {
        await dispatch(setTabCategory(categoryOrder[0]));
      }
    }
    await dispatch(checkInconsistentData());
  };
};

export const checkInconsistentData = () => {
  const { memos, categories } = store.getState();
  const { order, nowTabCategory, list } = categories;

  return async dispatch => {
    // 選択中カテゴリーを存在しないタブにしてしまっていた場合のエラー処理
    if (!list[nowTabCategory]) {
      await dispatch(setTabCategory(order[0]));
    }

    //Orderの中に、listに存在しない余計なカテゴリIdがいないかチェック
    order.map(async catId => {
      if (!Object.keys(list).includes(catId)) {
        await dispatch(consistentCatOrder());
      }
    });

    //listの中に、orderに存在しないカテゴリがいないかチェック
    Object.keys(list).map(async catId => {
      if (!order.includes(catId)) {
        await dispatch(consistentCatOrder());
      }
    });

    Object.keys(memos).map(async memoId => {
      //memoがtextもcatも無いデータだったら
      if (
        !memos[memoId].hasOwnProperty("text") ||
        !memos[memoId].hasOwnProperty("cat")
      ) {
        await dispatch(deleteMemo({ id: memoId }));
        return;
      }
      //memoがlistに存在しないカテゴリIdに属していないかチェック
      if (
        memos[memoId].cat[0] &&
        !Object.keys(list).includes(memos[memoId].cat[0])
      ) {
        await dispatch(archiveMemo({ id: memoId }));
      }
    });
  };
};
